// extracted by mini-css-extract-plugin
export default {"menuNav":"Menu_menuNav__IHJKr","menuList":"Menu_menuList__wkGRt","horizontalMenu":"Menu_horizontalMenu__+RbjV"};